import React, { Component, useState } from 'react'
import { GetCasesOfCustomer } from '../../api/support'
import { Alert, Row, Col, FormControl } from 'react-bootstrap'
import ListGroup from 'react-bootstrap/ListGroup'
import StatusMessage from "../../lib/statusmessage"
import moment from "moment"
import { withRouter } from "react-router-dom";
import LoadingModal from './loading-modal'
import PulseLoader from "react-spinners/PulseLoader";

class MyCaseList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Loading: false,
            Cases: null,
            StatusFilter: 0,
            EnvSettings: this.props.EnvSettings,
            InEU: this.props.InEU 
        }
        this.GetCases = this.GetCases.bind(this);
        this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
    }


    GetCases = async () => {

        try {
            this.setState({ Loading: true });
            let cases = await GetCasesOfCustomer();
            this.setState({ Cases: cases });
        } catch (ex) {
            this.setState({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: `${ex}`,
                }),
                Cases: []
            })
        } finally {
            this.setState({ Loading: false });
        }

    }

    handleStatusFilterChange = async ({ target }) => {
        this.setState({
            StatusFilter: target.options[target.selectedIndex].value
        });

    }

    onCaseSelected(c) {
        return this.props.history.push(`/case/${c.CaseNumber}`);
    }


    newCaseClick = () => {
        return this.props.history.push(`/newcase`);
    }


    componentWillMount() {
        this.GetCases();
    }

    componentDidUpdate(prevProps) {

        if (prevProps && prevProps.EnvSettings != this.props.EnvSettings) {
            this.setState({
                EnvSettings: this.props.EnvSettings
            })
        }
    }

    render() {
        return (
            <div className={`my-support-section my-support-case-list-wrap`}>
                {this.state.Alert &&
                    <Alert variant={this.state.Alert.Status}>
                        {this.state.Alert.Message}
                    </Alert>
                }
                <h2>My Cases</h2>
                {this.state.InEU &&
                    <Alert variant={`info`}>
                        Support cases for your geographic region must be submitted through our official European office. Please visit <a href="//www.mescius.eu">www.mescius.eu</a> to continue. <a href='/about/eu-office-information'>More Information</a>
                    </Alert>
                }
                <LoadingModal display={this.state.Loading} />
                <FormControl as={`select`} onChange={this.handleStatusFilterChange} value={this.state.StatusFilter}>
                    <option value={-1}>View All Cases</option>
                    <option value={0}>View Open Cases</option>
                    <option value={1}>View Closed Cases</option>
                </FormControl>
                {(() => {

                    return !this.state.Loading && this.state.Cases.length > 0 ? (() => {

                        let cases = this.state.Cases.sort((a, b) => { return moment(b.ModifiedOn) - moment(a.ModifiedOn) }).filter(x => {
                            if (this.state.StatusFilter != -1) {
                                return x.Status == this.state.StatusFilter
                            }
                            else return true;
                        }).map((c) => {

                            return (
                                <ListGroup.Item key={c.CaseGuid} action onClick={() => this.onCaseSelected(c)}>
                                    <Row>
                                        <Col md="6">
                                            <div>
                                                <h3>{c.Title}</h3>
                                                <p><strong>Created:</strong> {moment.utc(c.CreatedOn).local().format('D MMMM YYYY, h:mm a')}</p>
                                                <p><strong>Last Updated:</strong> {moment.utc(c.ModifiedOn).local().format('D MMMM YYYY, h:mm a')}</p>
                                            </div>
                                        </Col>
                                        <Col md="3">
                                            <p><span>Status:&nbsp;</span><strong>{c.StatusReason == 1 ? "Open" :
                                                c.StatusReason == 948160008 ? "With Support Team" :
                                                    c.StatusReason == 948160007 ? "Awaiting your response" :
                                                        c.StatusReason == 948160009 ? "Escalated to Development Team" :
                                                            c.StatusReason == 948160010 ? "Solution Provided" :
                                                                c.StatusReason == 948160011 ? "Closed as Resolved" :
                                                                    c.StatusReason == 948160012 ? "Closed as Unresolved" :
                                                                        c.StatusReason == 948160018 ? "Escalated to Sales Team" : "Open"
                                            }</strong></p>
                                        </Col>
                                        {c.ProductData &&
                                            <Col md="3">

                                                {(
                                                    () => {
                                                        let _settings = {};
                                                        if (c.ProductData?.Product && this.state.EnvSettings?.ProductSettings?.Products) {
                                                            _settings.Product = this.state.EnvSettings.ProductSettings.Products.find(x => {
                                                                return x.CRMProductGuid == c.ProductData.Product;
                                                            });

                                                            if (_settings.Product) {
                                                                _settings.Platform = _settings.Product.Platforms.find(x => {
                                                                    return x.CRMProductGuid == c.ProductData.Platform;
                                                                });
                                                                if (_settings.Platform) {
                                                                    _settings.Control = _settings.Platform.Controls.find(x => {
                                                                        return x.CRMProductGuid == c.ProductData.Control;
                                                                    });
                                                                }
                                                            }


                                                            return (
                                                                <>
                                                                    {c?.CaseNumber && <p><b>Case ID:</b> {c?.CaseNumber}</p>}
                                                                    {_settings.Product && <p><b>Product:</b> {_settings.Product.Name}</p>}
                                                                    {_settings.Platform && <p><b>Platform:</b> {_settings.Platform.Name}</p>}
                                                                    {_settings.Control && <p><b>Control:</b> {_settings.Control.Name}</p>}
                                                                </>
                                                            );
                                                        } else {
                                                            return <PulseLoader
                                                                size={10}
                                                                color={"#bbb"}
                                                                loading={true}
                                                            />
                                                        }
                                                    }
                                                )()}
                                            </Col>
                                        }
                                    </Row>
                                </ListGroup.Item>
                            )
                        })
                        return <ListGroup className={`my-support-case-list`}>
                            <ListGroup.Item key={"new-case"} className={`my-support-case-list-new-btn`} onClick={this.newCaseClick} action>
                                <Row>
                                    <Col>
                                        <p>Open A New Case</p>
                                    </Col>
                                </Row>
                            </ListGroup.Item>

                            <Row className={`my-support-case-list-header`}>
                                <Col md="6">
                                    Case Name
                                </Col>
                                <Col md="3" className={`d-none d-md-block`}>
                                    Status
                                </Col>
                                <Col md="3" className={`d-none d-md-block`}>
                                    Details
                                </Col>
                            </Row>

                            <Row className={`my-support-case-list-cases`}>
                                {cases}
                            </Row>

                        </ListGroup>

                    })() : this.state.Cases == null ? <p></p> : <ListGroup className={`my-support-case-list`}>
                        <ListGroup.Item key={"new-case"} className={`my-support-case-list-new-btn`} onClick={this.newCaseClick} action>
                            <Row>
                                <Col>
                                    <p>Open A New Case</p>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item className={`my-support-case-list-no-cases`} >
                            <Row>
                                <Col>
                                    <p>You have no cases to display.</p>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    </ListGroup>
                })()}
            </div>

        )
    }
}

export default withRouter(MyCaseList);